import * as Res from "@discovery/sonic-api-ng/lib/japi/response";
import { Fold, Lens } from "@discovery/prelude/lib/control/lens";
import * as Optics from "@discovery/sonic-api-ng-optics";
import * as M from "@discovery/prelude/lib/data/maybe";
export const _Show2Genres = Fold.compose(Optics._Col2Items, Optics._ColItem2Show, Optics._Show2TxGenres, Optics._TxNodeAttributes2Name);
export const _ActiveVideoRoute = Fold.compose(Optics._Video2Routes, Optics._Route2AttributesFiltered({ canonical: true }), Lens.prop("url"));
export const _ActiveVideoType = Fold.compose(Optics._Video2Data, Lens.path("attributes", "videoType"));
export const _ActiveVideoSeasonId = Fold.compose(Optics._Video2Data, Lens.path("attributes", "seasonNumber"));
export const _ShowName = Fold.compose(Optics._Col2Items, Res._Rel("video"), Res._Rel("show"), Res._Response(), Lens.path("attributes", "name"));
export const _ViewingHistory = Fold.compose(Optics._Video2Data, Fold.liftM((viewingHistory, videoDuration) => ({
    viewed: viewingHistory.viewed,
    completedM: viewingHistory.completed,
    positionM: viewingHistory.position,
    videoDurationM: videoDuration,
}), Fold.compose(Lens.path("attributes", "viewingHistory"), M._Just()), Lens.path("attributes", "videoDuration")));
export const _ActiveVideoAudioTracks = Fold.compose(Optics._Video2Data, Fold.liftM((attributes) => ({
    languages: M.fromMaybe(attributes.audioTracks, []),
    subtitles: [],
}), Lens.prop("attributes")));
export const _PrimaryChannelTitleShow = Fold.compose(Optics._Col2Items, Res._Rel("show"), Optics._Show2PrimaryChannel, Res._Response(), Lens.path("attributes", "name"));

